/* global angular */

(function () {
    "use strict";

    var Types = {
        DOCUMENT: 5,
        EVENT: 9
    };

    var app = angular.module('app');

    app.controller('UserCtrl', ['$rootScope', '$scope', '$q', '$sce', 'State', 'api', 'Account', 'Booking', 'Wishlist', 'gtm', 'CONFIG', function ($rootScope,$scope, $q, $sce, State, api, Account, Booking, Wishlist, gtm, CONFIG) {
        
        var state = new State(),
            stateUser = new State();
        var loc = CONFIG.app.locale;
        var model = {};

        var sources = {
            area: 1,
            purchases: { items: [] }
        };
        state.busy();
        $q.all([
            api.data.billing().then(function (response) {
                sources.countries = response.data.countries;
                sources.provinces = response.data.provinces;
                sources.paymentTypes = response.data.paymentTypes;
            }),
            Wishlist.current().then(function (response) {
                //
            }),
            /*Account.getUser(true).then(function (response) {
                sources.user = response;
            }),
            */
            api.user.me().then(function (response) {
                setUser(response.data);
            }),
            api.user.offers().then(function (response) {
                sources.offers = response.data;                
                if (sources.offers && sources.offers.length > 0) {
                    sources.area = 4;
                }
            })
        ]).then(function success(response) {                
            state.ready();
        }, function error(response) {
            state.error(response);
        });

        function logout() {
            if (state.busy()) {
                api.user.logout().then(function () {                    
                    gtm.push({
                        event: 'Logout',
                        user: Account.user.id,
                        user_type: Account.user.profile
                    });
                    state.success();
                    Account.setUser(null);
                    Booking.getCart();
                    $rootScope.$broadcast('onAuthUserChange');   
                    if ($scope.modal) {
                        $scope.modal.reject(null);
                    }
                });
            }
        }

        function openItem(item) {
            if (item.type === Types.EVENT) {
                api.data.topservicedetail(item.id).then(function (response) {
                    var item = response.data;
                    $scope.$root.addModal('bookModal', item).then(function (data) {
                    }, function () {
                    });
                }, function (error) {
                });
            } else {
                window.location.href = item.url;
            }
            return true;
        }

        function save() {
            if (Account.hasBillingInfo()) {
                updateBillinginfo();
            } else {
                registerBillinginfo();
            }
        }

        function updateBillinginfo() {
            if (stateUser.busy()) {
                api.user.edit(model).then(function (response) {
                    stateUser.success();
                    Account.setUser(response.data);
                    setUser(response.data);

                },function error(response) {
                    stateUser.error(response);

                });
            }
        }

        function registerBillinginfo() {
            if (stateUser.busy()) {
                model.name = model.lastName + "  " + model.firstName;
                api.user.register(model).then(function (response) {
                    stateUser.success();
                    // autologin
                    model.customerCode = response.data;
                    model.customerPsw = model.password;
                    api.user.login(model).then(function (response) {                        
                        gtm.push({
                            event: 'Register', user: response.data.id
                        });
                        gtm.push({
                            event: 'Login',user: response.data.id
                        });
                        Account.setUser(response.data);
                        setUser(response.data);

                    }, function (error) {
                        stateUser.error(error);

                    });
                }, function (error) {
                    stateUser.error(error);

                });
            }
        }
        
        function setUser(data) {
            sources.user = data;
            angular.extend(model, sources.user);
            //console.log('user', sources.user);
        }

        $scope.state = state;
        $scope.stateUser = stateUser;
        $scope.loc = loc;
        $scope.sources = sources;
        $scope.model = model;
        $scope.logout = logout;
        $scope.openItem = openItem;
        $scope.save = save;        
        
    }]);
    
    app.service('Wishlist', ['$q', '$sce','$rootScope', 'api', 'gtm', 'LocalStorage', function ($q, $sce, $rootScope, api, gtm, storage) {
        var service = this,
            items = [],
            key = 'wishlist';

        function current() {
            var deferred = $q.defer();
            if (storage.exists(key)) {
                var data = storage.get(key);
                items = this.items = data;
                deferred.resolve(items);
                get();
            } else {
                return get();
            }
            return deferred.promise;
        }

        function get() {
            var deferred = $q.defer();
            api.user.wishlist().then(function (response) {
                var data = response.data || [];
                set(data);
                deferred.resolve(data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function set(data) {
            items = service.items = data;
            storage.set(key, items);
            $rootScope.$broadcast('onWishListChange');
            return items;
        }

        function has(id) {
            var index = -1;
            angular.forEach(items, function (value, i) {
                if (value === id) {
                    index = i;
                }
            });
            if (index !== -1) {
                return items[index];
            } else {
                return null;
            }
        }

        function add(id) {
            var deferred = $q.defer();            
            api.user.addToWishlist(id).then(function (response) {                
                gtm.addToWishlist(id);
                get();
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function remove(id) {
            var deferred = $q.defer();
            api.user.removeFromWishlist(id).then(function (response) {
                gtm.removeFromWishlist(id);
                get();
                deferred.resolve(items);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function toggle(id) {      
            console.log('toggle', id);
            if (has(id)) {
                return remove(id);
            } else {
                return add(id);
            }            
        }

        function clear() {
            var deferred = $q.defer();
            api.user.clearWishlist(id).then(function (response) {
                items = set([]);
                deferred.resolve(items);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        this.items = items;
        this.current = current;
        this.get = get;
        this.set = set;
        this.has = has;
        this.add = add;
        this.remove = remove;
        this.toggle = toggle;
        this.clear = clear;
        
    }]);
    
}());